import { useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHsCodesRequest, clearHsCodes } from 'redux/reducers/hscodes/reducer';
import { getHsCodesItems, getHsCodesLoading } from 'redux/reducers/hscodes/selectors';
import { AppDispatch } from 'redux/store';

let debounceTimer: NodeJS.Timeout;

type HsCodeSearchMode = 'search-by-name' | 'search-by-code';

export const useHsCodesRedux = (
	searchTerm: string,
	searchMode: HsCodeSearchMode = 'search-by-code',
) => {
	const dispatch = useDispatch<AppDispatch>();

	const options = useSelector(getHsCodesItems);
	const loading = useSelector(getHsCodesLoading);

	const debouncedSearch = useCallback(
		(term: string, mode: HsCodeSearchMode) => {
			clearTimeout(debounceTimer);

			debounceTimer = setTimeout(() => {
				if (!term || term.length < 2) {
					dispatch(clearHsCodes());
					return;
				}

				// Формируем параметры запроса в зависимости от режима поиска
				const requestParams = mode === 'search-by-name' ? { query: term } : { hsCode: term };

				dispatch(getHsCodesRequest(requestParams));
			}, 100);
		},
		[dispatch],
	);

	useEffect(() => {
		debouncedSearch(searchTerm, searchMode);

		return () => {
			clearTimeout(debounceTimer);
		};
	}, [searchTerm, searchMode, debouncedSearch]);

	return useMemo(
		() => ({
			options,
			loading,
		}),
		[options, loading],
	);
};
